import { queryGetG500LiteMasterInfoWithOrganizationId } from '../api/queryGetG500LiteMasterInfoWithOrganizationId';
import {
	g500LiteGetType,
	sessionStorageKeyAuthorizationToken,
	dialog,
	masterInfoLabel,
	applicableData,
	allCarInfo,
	allDriverInfo,
} from '../const/commonConst';
import { HandlerOutputType } from '../type/HandlerType';
import { G500LiteMasterInfoLinkedToOrganization } from '../type/MasterInfoType';
import { responseType } from '../type/ResponseType';
import { isResponseTypeError, isResponseTypeSessionNotExist } from '../utils/responseTypeChecker';
import { convertCarInfoList, convertDriverInfoList } from '../utils/masterInfoConverter';
import { nonNullable } from '../utils/nonNullable';
import { getSessionStorage } from '../utils/sessionStorageHandler';
import { redirectToLogin } from '../utils/redirectToLogin';

/**
 * G500Liteの組織IDに紐づくマスタ情報を取得する関数
 */
export const getG500LiteMasterInfoWithOrganizationIdHandler = async (
	getType: (typeof g500LiteGetType)[keyof typeof g500LiteGetType],
	organizationId?: string,
): Promise<HandlerOutputType<G500LiteMasterInfoLinkedToOrganization>> => {
	// 認証トークンを取得する
	const authorizationToken = getSessionStorage(sessionStorageKeyAuthorizationToken);

	if (!authorizationToken) {
		return [dialog.systemError, undefined];
	}

	const getMasterInfoInput = {
		authorizationToken: authorizationToken,
		organizationId: organizationId,
	};

	try {
		// G500Liteのマスタ情報を取得する
		const [isApiError, getMasterInfoResult] = await queryGetG500LiteMasterInfoWithOrganizationId(getType, getMasterInfoInput, authorizationToken);
		console.log(getMasterInfoResult);

		if (isApiError || !getMasterInfoResult || isResponseTypeError(getMasterInfoResult)) {
			return [dialog.apiError, undefined];
		}

		if (isResponseTypeSessionNotExist(getMasterInfoResult)) {
			redirectToLogin();
		}

		const notExistedList: string[] = [];
		if (getMasterInfoResult.getG500LiteCarInfo && getMasterInfoResult.getG500LiteCarInfo.responseType === responseType.notExistApiResponseData) {
			notExistedList.push(masterInfoLabel.g500LiteCar);
		}

		if (
			getMasterInfoResult.getG500LiteDriverInfo &&
			getMasterInfoResult.getG500LiteDriverInfo.responseType === responseType.notExistApiResponseData
		) {
			notExistedList.push(masterInfoLabel.g500LiteDriver);
		}

		if (notExistedList.length) {
			const customDialog = {
				isOpened: dialog.notExistMasterInfo.isOpened,
				title: dialog.notExistMasterInfo.title,
				text: dialog.notExistMasterInfo.text.replace(applicableData, notExistedList.join()), // カンマ区切で連結
			};
			return [customDialog, undefined];
		}

		const masterInfo: G500LiteMasterInfoLinkedToOrganization = {
			g500LiteCarInfoList: getMasterInfoResult.getG500LiteCarInfo
				? [allCarInfo, ...convertCarInfoList(getMasterInfoResult.getG500LiteCarInfo.carInfoList.filter(nonNullable))]
				: [],
			g500LiteDriverInfoList: getMasterInfoResult.getG500LiteDriverInfo
				? [allDriverInfo, ...convertDriverInfoList(getMasterInfoResult.getG500LiteDriverInfo.driverInfoList.filter(nonNullable))]
				: [],
		};

		return [dialog.success, masterInfo];
	} catch (err: unknown) {
		console.error(err);
		return [dialog.systemError, undefined];
	}
};
